"use strict";
/**
 * Pair builder data loader for Kalshi and Polymarket US markets.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadPairBuilderKalshiMarkets = loadPairBuilderKalshiMarkets;
exports.loadPairBuilderPolymarketMarkets = loadPairBuilderPolymarketMarkets;
const kalshi_1 = require("../api/kalshi");
const polymarket_us_1 = require("../api/polymarket-us");
const state_1 = require("../state");
const monitor_state_service_1 = require("./monitor-state-service");
const DEFAULT_KALSHI_EVENT_LIMIT = 200;
const DEFAULT_PM_MARKET_LIMIT = 200;
async function loadPairBuilderKalshiMarkets(category) {
    (0, monitor_state_service_1.setPairBuilderMarkets)({ kalshiLoading: true });
    try {
        const selectedCategory = category ?? (0, state_1.getState)().pairBuilder.kalshiCategory;
        const eventsResponse = await (0, kalshi_1.getEvents)(DEFAULT_KALSHI_EVENT_LIMIT, selectedCategory, undefined, true, "open", Math.floor((Date.now() - 24 * 60 * 60 * 1000) / 1000));
        const events = eventsResponse.events ?? [];
        const markets = events.flatMap((event) => {
            const nested = Array.isArray(event.markets) ? event.markets : [];
            return nested.map((market) => ({
                ticker: market.ticker,
                title: market.title,
                eventTitle: event.title,
                eventTicker: event.event_ticker,
                status: market.status,
            }));
        });
        (0, monitor_state_service_1.setPairBuilderMarkets)({
            kalshiMarkets: markets,
            kalshiCategory: selectedCategory,
            kalshiLoading: false,
        });
    }
    catch (error) {
        console.error("Failed to load Kalshi markets:", error);
        (0, monitor_state_service_1.setPairBuilderMarkets)({ kalshiMarkets: [], kalshiLoading: false });
    }
}
async function loadPairBuilderPolymarketMarkets() {
    (0, monitor_state_service_1.setPairBuilderMarkets)({ pmLoading: true });
    try {
        const state = (0, state_1.getState)().pairBuilder;
        const response = await (0, polymarket_us_1.listPolymarketUsEvents)({
            limit: DEFAULT_PM_MARKET_LIMIT,
            active: true,
            closed: false,
            startTimeMin: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
            tagSlug: state.pmSport || undefined,
            // The pair builder's dropdown is a flat list of every market in
            // the sport, so it opts into nested markets. This is the one heavy
            // PM-US call left; the arb monitor it feeds is dormant.
            include: ["markets"],
        });
        const payload = response.data ?? [];
        const events = Array.isArray(payload)
            ? payload
            : Array.isArray(payload.events)
                ? payload.events
                : [];
        const mapped = events.flatMap((event) => {
            const markets = Array.isArray(event.markets)
                ? event.markets
                : [];
            return markets.map((market) => ({
                id: Number(market.id ?? 0),
                slug: String(market.slug ?? ""),
                question: String(market.question ?? market.title ?? ""),
                eventTitle: event.title ?? event.name,
                active: Boolean(market.active ?? event.active),
                closed: Boolean(market.closed ?? event.closed),
            }));
        });
        (0, monitor_state_service_1.setPairBuilderMarkets)({ pmUsMarkets: mapped, pmLoading: false });
    }
    catch (error) {
        console.error("Failed to load PM-US markets:", error);
        (0, monitor_state_service_1.setPairBuilderMarkets)({ pmUsMarkets: [], pmLoading: false });
    }
}
